/**
 * CoordinateTypes
 */
export interface CoordinateTypes {
    /**
     * getLatitude
     */
    getLatitude(): number;
    /**
     * getLongitude
     */
    getLongitude(): number;
}
